import { useDispatch } from 'react-redux';
import {
    login,
    logout,
    clearStore,
    loginWithOher,
    privacyAllow,
    step1Allow,
    step2Allow,
    step3Allow,
    step4Allow
} from '../reducers/loginReducer';
import { e3 } from 'src/framework/core/utils/utils';

export const SAVE_SESSION_FOR_ACCOUNT_NAME = 'loginSign';
const APP_TYPE = process.env.REACT_APP_TYPE;
const LOGIN_ACCESS_CUSTOMER = APP_TYPE === 'E3PUBLIC' ? true : false; // 안전교육 대상자
/**
 * 로그인 처리 및 세션 저장소에 데이타 저장 처리
 */
export default function useSessionStorage(name) {
    const dispatcher = useDispatch();
    const callLogin = (data) => dispatcher(login(data));
    const callLogout = () => dispatcher(logout());
    const callLoginWithOher = (data) => dispatcher(loginWithOher(data));
    const callPrivacyAllow = () => dispatcher(privacyAllow());
    const callStep1Allow = () => dispatcher(step1Allow());
    const callStep2Allow = () => dispatcher(step2Allow());
    const callStep3Allow = () => dispatcher(step3Allow());
    const callStep4Allow = () => dispatcher(step4Allow());
    const callClearStore = () => dispatcher(clearStore());
    const clearSessionStorage = (isLogoutReducer = false) => {
        window.sessionStorage.clear();
        if (isLogoutReducer) {
            callClearStore();
            callLogout();
        }
    };
    const saveSessionStorage = (value, isLoginReducer = false) => {
        const val = typeof value !== 'string' ? JSON.stringify(value) : value;
        window.sessionStorage.setItem(name, e3.base64Encode(val));
        if (LOGIN_ACCESS_CUSTOMER) {
            if (isLoginReducer) {
                callLoginWithOher(value);
            }
        } else {
            if (isLoginReducer) callLogin(value);
        }
    };
    const loadSessionStorage = () => {
        const tmp = window.sessionStorage.getItem(name);
        const ret = tmp && tmp.length > 0 ? JSON.parse(e3.base64Decode(tmp.toString())) : undefined;
        return ret;
    };

    const setLoginWithOher = (value) => {
        const val = typeof value !== 'string' ? JSON.stringify(value) : value;
        window.sessionStorage.setItem(name, e3.base64Encode(val));
        callLoginWithOher(value);
    };
    const setPrivacyAllow = () => {
        callPrivacyAllow();
    };
    const setStep1Allow = () => {
        callStep1Allow();
    };
    const setStep2Allow = () => {
        callStep2Allow();
    };
    const setStep3Allow = () => {
        callStep3Allow();
    };
    const setStep4Allow = () => {
        callStep4Allow();
    };

    return {
        clearSessionStorage,
        saveSessionStorage,
        loadSessionStorage,
        setLoginWithOher,
        setPrivacyAllow,
        setStep1Allow,
        setStep2Allow,
        setStep3Allow,
        setStep4Allow
    };
}

export function saveSession(sessionName, seaaionValue) {
    const val = typeof seaaionValue !== 'string' ? JSON.stringify(seaaionValue) : seaaionValue;
    window.sessionStorage.setItem(sessionName, val);
}
export function loadSession(sessionName) {
    const tmp = window.sessionStorage.getItem(sessionName);
    const ret = tmp && tmp.length > 0 ? tmp.toString() : undefined;
    return ret;
}
